import { Address } from '@modules/checkout-store';

export interface IDirectDebitBankDetails {
  bankName?: string;
  branchName: string;
  bankAddress?: Address;
  valid: boolean;
}
